<bb-page-header *ngIf="entity" [backOnMobile]="['/library/social']" [icon]="'instagram'" [title]="entity.remotePageTitle">

	<ul class="tabs">
		<li>
			<a [routerLink]="['/library/social/instagram', activeId, 'general']" routerLinkActive="active">
				<i class="fa fa-tags"></i> {{ 'GENERAL' | translate }}
			</a>
		</li>
	</ul>

	<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [valueOn]="'active'" [valueOff]="'inactive'" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" ></bb-status>
</bb-page-header>

<form #formRef="ngForm" [ngClass]="{'preview-active': preview}">
	<div class="body-column tab-container" [ngClass]="{'preview-active': previewActive}" *ngIf="entity">

		<div class="header">{{'INSTAGRAM_ACCOUNT' | translate}}</div>
		<bb-form-element [form]="form">
			<social-channel-card *ngIf="entity.id" [banner]="entity.remoteBannerImageUrl"
			[logo]="entity.remoteLogoImageUrl" [title]="entity.remotePageTitle"
			[url]="entity.remoteUrl" [authentication]="isNew"></social-channel-card>
			<div class="auth-text">{{ (isNew ? 'ACCOUNT_NOT_AUTHENTICATED' : 'ACCOUNT_AUTHENTICATED') | translate }}</div>
			<bb-button [disabled]="isDisabled" icon="instagram" (click)="authenticate()">{{ (entity.id ? 'RE_AUTHENTICATE' : 'AUTHENTICATE') | translate }}</bb-button>
		</bb-form-element>
	
		<hr/>

		<bb-form-element [form]="form" label="{{'DESCRIPTION' | translate}}">
			<textarea [(ngModel)]="entity.description" type="text" name="description">{{entity.description}}</textarea>
		</bb-form-element>

		<bb-form-element [form]="form" label="{{'INSTAGRAM_PAGE' | translate}}" [hidden]="!accountOptions.length">
			<bb-select [(ngModel)]="entity.remotePageId" name="remotePageId" [options]="accountOptions" (optionSelected)="onPageSelected($event)"></bb-select>
		</bb-form-element>
		
	</div>

	<div class="body-column preview-container" [ngClass]="{'preview-active': previewActive}">
		<social-facebook-synced [channel]="entity"></social-facebook-synced>
	</div>
</form>

<bb-actions-bar (onSave)="save($event)" (onCancel)="cancel()" (onDelete)="delete($event)" [form]="form" [entity]="entity">
	<span *ngIf="entity && entity.mediatype==='video'" class="action-button" [ngClass]="{'active': preview}" (click)="preview = !preview">{{ 'PREVIEW' | translate }}</span>
</bb-actions-bar>
